// extracted by mini-css-extract-plugin
module.exports =  {"list":"_33974c2b58--list--tDoH0"};